import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { getGuestCart, setGuestCart } from "./cartStorage";
import "./Cart.css";
import { toast } from "react-toastify";
import logo from "../../asset/logo512.png";

function Cart() {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("access");
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [errorItemId, setErrorItemId] = useState(null);
  const [errorType, setErrorType] = useState(null);

  useEffect(() => {
    if (isLoggedIn) {
      axiosInstance
        .get("/cart/cart/")
        .then((res) => setCart(res.data))
        .catch(() => setCart([]))
        .finally(() => setLoading(false));
    } else {
      setCart(getGuestCart());
      setLoading(false);
    }
  }, [isLoggedIn]);
  if (loading) {
    return (
      <div className="cart-loading">
        <img src={logo} alt="Loading..." className="loading-logo" />
        <p>Loading cart...</p>
      </div>
    );
  }
const normalizedCart = cart.map((item) => {

  // Logged-in user cart (API response)
  if (item.product) {

    const selectedSize =
      item.size ||
      item.product?.sizes?.find((s) => s.id === item.size?.id) ||
      item.product?.sizes?.[0] ||
      null;

    return {
      cart_id: item.id,
      product_id: item.product.id,
      title: item.product.product_title,

      price: selectedSize?.price || item.product.price || 0,

      size: selectedSize,
      product_sizes: item.product.sizes || [],

      quantity: item.quantity,
      image: item.product.images?.[0]?.image || "",
      category: item.product.category?.name || "",

      number_plate: item.number_plate || "",
      color: item.color || null,
      product_colors: item.product.colors || [],
    };
  }

  // Guest cart (localStorage)
  return {
    cart_id: null,
    product_id: item.product_id,
    title: item.title,

    price: item.size?.price || item.price || 0,

    size: item.size || null,
    product_sizes: item.product_sizes || [],

    quantity: item.quantity,
    image: item.image,
    category: item.category || "",

    number_plate: item.number_plate || "",
    color: item.color || null,
    product_colors: item.product_colors || [],
  };

});

  const total = normalizedCart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const goToProduct = (productId) => {
    navigate(`/product/${productId}`);
  };

  const updateQty = (item, qty) => {
    if (qty < 1) return;

    if (isLoggedIn) {
      axiosInstance
        .put("/cart/cart/", {
          cart_id: item.cart_id,
          quantity: qty,
        })
        .then(() => {
          setCart((prev) =>
            prev.map((c) =>
              c.id === item.cart_id ? { ...c, quantity: qty } : c
            )
          );
          window.dispatchEvent(new Event("cartUpdated"));
        });
    } else {
      const updated = normalizedCart.map((c) =>
        c.product_id === item.product_id &&
c.size?.id === item.size?.id
          ? { ...c, quantity: qty }
          : c
      );
      setGuestCart(updated);
      setCart(updated);
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };
const updateSize = (item, sizeId) => {

  const sizeObj = item.product_sizes.find(s => s.id === sizeId);

  if (isLoggedIn) {

    axiosInstance.put("/cart/cart/", {
      cart_id: item.cart_id,
      size: sizeId,
    }).then(() => {
      setCart(prev =>
        prev.map(c =>
          c.id === item.cart_id
            ? { ...c, size: sizeObj, price: sizeObj.price }
            : c
        )
      );
    });

  } 
else {
const updated = normalizedCart.map((c) => {

  const isSameItem =
    c.product_id === item.product_id &&
    c.size?.id === item.size?.id &&
    c.color?.id === item.color?.id &&
    c.number_plate === item.number_plate;

  return isSameItem ? { ...c, size: sizeObj, price: sizeObj.price } : c;
});

  setGuestCart(updated);
  setCart(updated);
}
};
  /* ---------------- UPDATE COLOR ---------------- */
  const updateColor = (item, colorId) => {
    if (isLoggedIn) {
      axiosInstance
        .put("/cart/cart/", {
          cart_id: item.cart_id,
          color: colorId,
        })
        .then(() => {
          setCart((prev) =>
            prev.map((c) =>
              c.id === item.cart_id
                ? { ...c, color: { id: parseInt(colorId) } }
                : c
            )
          );
        });
    } else {
      const updated = normalizedCart.map((c) =>
        c.product_id === item.product_id &&
c.size?.id === item.size?.id
          ? { ...c, color: { id: parseInt(colorId) } }
          : c
      );
      setGuestCart(updated);
      setCart(updated);
    }
  };

const updateNumberPlate = (item, value) => {
  if (isLoggedIn) {
    axiosInstance
      .put("/cart/cart/", {
        cart_id: item.cart_id,
        number_plate: value,
      })
      .then(() => {
        setCart((prev) =>
          prev.map((c) =>
            c.id === item.cart_id
              ? { ...c, number_plate: value }
              : c
          )
        );
      });
  } else {

    const updated = normalizedCart.map((c) =>
      c.product_id === item.product_id &&
      c.size?.id === item.size?.id
        ? { ...c, number_plate: value }
        : c
    );

    setGuestCart(updated);
    setCart(updated);
  }
};

  const removeItem = (item) => {
    if (isLoggedIn) {
      axiosInstance
        .delete(`/cart/cart/?cart_id=${item.cart_id}`)
        .then(() => {
          setCart((prev) =>
            prev.filter((c) => c.id !== item.cart_id)
          );
          window.dispatchEvent(new Event("cartUpdated"));
        });
    } else {
const updated = normalizedCart.filter((c) => {

  const isSameItem =
    c.product_id === item.product_id &&
    c.size?.id === item.size?.id &&
    c.color?.id === item.color?.id &&
    c.number_plate === item.number_plate;

  return !isSameItem;
});
      setGuestCart(updated);
      setCart(updated);
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };

  const handleCheckout = () => {
    if (!isLoggedIn) {
      navigate("/login", {
        state: {
          from: "/checkout",
          cart: normalizedCart,
          total: total,
        },
      });
      return;
    }

    for (let item of normalizedCart) {
      const categoryName = item.category?.toLowerCase();
      const isCustomTextProduct =
        categoryName === "number plate" ||
        categoryName === "name board";

      if (item.product_colors?.length > 0 && !item.color) {
        setErrorItemId(item.cart_id || item.product_id);
        setErrorType("color");
        toast.error(`Please select color for ${item.title}`);
        return;
      }

      if (
        isCustomTextProduct &&
        (!item.number_plate || item.number_plate.trim() === "")
      ) {
        setErrorItemId(item.cart_id || item.product_id);
        setErrorType("number");

        toast.error(
          categoryName === "number plate"
            ? `Please enter vehicle number for ${item.title}`
            : `Please enter name board text for ${item.title}`
        );
        return;
      }
    }

    setErrorItemId(null);
    setErrorType(null);

    navigate("/checkout", {
      state: { cart: normalizedCart, total },
    });
  };

  if (normalizedCart.length === 0) {
    return (
      <div className="empty-cart">
        <img
          src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
          alt="Empty Cart"
          className="empty-cart-img"
        />

        <h2>Your Cart is Empty 🛒</h2>
        <p>Looks like you haven't added anything yet.</p>

        <button
          className="shop-btn"
          onClick={() => navigate("/")}
        >
          Continue Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h2 className="cart-title">🛒 Your Cart</h2>

      <div className="cart-list">
        {normalizedCart.map((item) => (
          <div
           key={`${item.product_id}-${item.size?.id}-${item.color?.id}-${item.number_plate}`}
            className={`cart-card ${errorItemId === (item.cart_id || item.product_id)
              ? "cart-error"
              : ""
              }`}
          >
            <img
              className="cart-img"
              src={item.image}
              alt={item.title}
              onClick={() => goToProduct(item.product_id)}
              style={{ cursor: "pointer" }}
            />
            <div className="cart-details">
              <h4
                onClick={() => goToProduct(item.product_id)}
                style={{ cursor: "pointer" }}
              >
                {item.title}
              </h4>

              <p className="price">₹ {(item.price || 0).toLocaleString()}</p>
{item.product_sizes?.length > 0 && (
  <div>
    <p><b>Select Size:</b></p>

    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
      {item.product_sizes.map((sz) => (
        <button
          key={sz.id}
          onClick={() => updateSize(item, sz.id)}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
border:
  item.size?.id === sz.id
    ? "2px solid black"
    : "1px solid #ccc",
background:
  item.size?.id === sz.id
    ? "#f5f5f5"
    : "white",
            cursor: "pointer",
          }}
        >
          {sz.size}
        </button>
      ))}
    </div>
  </div>
)}
              {/* COLOR SELECT */}
              {item.product_colors?.length > 0 && (
                <div
                  className={
                    errorType === "color" &&
                      errorItemId ===
                      (item.cart_id || item.product_id)
                      ? "input-error"
                      : ""
                  }
                >
                  <p><b>Select Color:</b></p>
                  <div style={{ display: "flex", gap: 10 }}>
                    {item.product_colors.map((clr) => (
                      <div
                        key={clr.id}
                        onClick={() =>
                          updateColor(item, clr.id)
                        }
                        style={{
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                          backgroundColor:
                            clr.hex_code || "#ddd",
                          border:
                            item.color?.id === clr.id
                              ? "3px solid black"
                              : "1px solid #ccc",
                          cursor: "pointer",
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

              {/* CUSTOM TEXT FIELD */}
              {(() => {
                const categoryName =
                  item.category?.toLowerCase();
                const isCustomTextProduct =
                  categoryName === "number plate" ||
                  categoryName === "name board";

                if (!isCustomTextProduct) return null;

                return categoryName ===
                  "number plate" ? (
                  <input
                    type="text"
                    placeholder="Enter Vehicle Number"
                    value={item.number_plate}
                    onChange={(e) =>
                      updateNumberPlate(
                        item,
                        e.target.value
                          .toUpperCase()
                          .replace(/[^A-Z0-9]/g, "")
                      )
                    }
                    className={
                      errorType === "number" &&
                        errorItemId ===
                        (item.cart_id ||
                          item.product_id)
                        ? "input-error"
                        : ""
                    }
                    style={{
                      padding: "8px",
                      width: "250px",
                      borderRadius: "5px",
                      textTransform: "uppercase",
                    }}
                  />
                ) : (
                  <textarea
                    placeholder="Enter Name Board Text"
                    value={item.number_plate}
                    onChange={(e) =>
                      updateNumberPlate(
                        item,
                        e.target.value
                      )
                    }
                    rows={3}
                    className={`responsive-textarea ${errorType === "number" &&
                      errorItemId === (item.cart_id || item.product_id)
                      ? "input-error"
                      : ""
                      }`}
                  />
                );
              })()}

              <div className="qty-box">
                <button
                  onClick={() =>
                    updateQty(item, item.quantity - 1)
                  }
                >
                  -
                </button>
                <span>{item.quantity}</span>
                <button
                  onClick={() =>
                    updateQty(item, item.quantity + 1)
                  }
                >
                  +
                </button>
              </div>

              <button
                className="remove-btn"
                onClick={() => removeItem(item)}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="total-box">
        <h3>Total Amount: ₹ {total.toLocaleString()}</h3>
        <button
          className="checkout-btn"
          onClick={handleCheckout}
        >
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
}

export default Cart;